import { render, staticRenderFns } from "./OneProductStocks.vue?vue&type=template&id=3f73392c&scoped=true&lang=pug&"
import script from "./OneProductStocks.vue?vue&type=script&lang=ts&"
export * from "./OneProductStocks.vue?vue&type=script&lang=ts&"
import style0 from "./OneProductStocks.vue?vue&type=style&index=0&id=3f73392c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f73392c",
  null
  
)

export default component.exports